import React, { FC, useContext } from "react";
import { ReactComponent as Loader } from "../assets/svg/loader.svg";
import { Modal } from "./_ui";
import { WidgetContext } from "../context";
import { LG } from "../constants";
interface IModal {
  openModal: boolean;
  openInfoModal: boolean;
  modalType: string | null;
  setOpenModal: (v: boolean) => void;
  setOpenInfoModal: (v: boolean) => void;
  setModalType: (v: "info" | "not found" | null) => void;
  isLoading: boolean;
}

const Modals: FC<IModal> = ({
  openModal,
  setOpenModal,
  setModalType,
  modalType,
  setOpenInfoModal,
  openInfoModal,
  isLoading,
}) => {
  const {
    config: { lg },
  } = useContext(WidgetContext);
  return (
    <>
      {openModal && modalType === "not found" && (
        <Modal
          title={LG[lg].OrderNotFound}
          description={LG[lg].CheckCorrect}
          actionTitle={LG[lg].back}
          onClose={() => {
            setOpenModal(false);
            setModalType(null);
          }}
        />
      )}
      {openInfoModal && modalType === "info" && (
        <Modal
          title=""
          description={LG[lg].UnderDevelop}
          onClose={() => {
            setOpenInfoModal(false);
            setModalType(null);
          }}
        />
      )}
      {isLoading && <Loader />}
    </>
  );
};

export default Modals;
